/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.16.0
 */
import { useCallback } from 'react';


import { Button, LinkBlock } from '@components/common';
import { API_HOSTNAME, IMPORT_PERSONAL_DATA_EXPORT_ERROR, WIZARD, WIZARD_ACTION } from '@modules/app/Api';
import { IImportPersonalDataExportModal } from '@modules/internationalization/types/wizards/importPersonalData';
import {
    ModalPopupContainerStyled,
    ModalPopupControlContainer,
    ModalPopupTextStyled,
    ModalPopupTitleStyled,
} from '@modules/modal/components/styled/ModalStyled';
import { IModalRenderProps } from '@modules/modal/types/modalTypes';
import { EWizardName } from '@modules/wizard/wizardConstants';
import { openExternalRoute } from '@routes/constants/externalRoutes';
import { stringFormat } from '@utils/stringFormat';


export interface IWizardImportPersonalDataExportModalInfo extends Pick<IModalRenderProps, 'onCloseModal'> {
    translation: IImportPersonalDataExportModal;
}

const WizardImportPersonalDataExportModal = (props: IWizardImportPersonalDataExportModalInfo) => {
    const {
        translation,
        onCloseModal,
    } = props;

    const exportErrorsHandler = useCallback(() => {
        const url = API_HOSTNAME + stringFormat(WIZARD, EWizardName.IMPORT_PERSONAL_DATA)
            + stringFormat(WIZARD_ACTION, IMPORT_PERSONAL_DATA_EXPORT_ERROR);

        onCloseModal();
        openExternalRoute(url, '_blank');
    }, [onCloseModal]);

    return <ModalPopupContainerStyled
        data-component={'modal-popup'}
        data-name={'wizard-import-personal-data-export-error-modal'}
        width='580px'
    >
        <ModalPopupTitleStyled data-name="modal-popup-title">
            {translation.title}
        </ModalPopupTitleStyled>
        <ModalPopupTextStyled data-name="modal-popup-text">
            {translation.info}
        </ModalPopupTextStyled>
        <ModalPopupControlContainer>
            <Button
                dataName="wizard-import-personal-data-export-error-btn"
                height='32px'
                kind="medium"
                onClick={exportErrorsHandler}
            >
                {translation.exportButton}
            </Button>
            <LinkBlock onClick={onCloseModal}>
                {translation.closeButton}
            </LinkBlock>
        </ModalPopupControlContainer>
    </ModalPopupContainerStyled>;
};

export default WizardImportPersonalDataExportModal;
